module.exports = __webpack_public_path__ + "static/media/card_s3.1efbb81c.jpg";